import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Pager } from '../../public-api';
import { AbstractService } from '../commons/abstract.service';
import { SearchParams } from '../commons/abstract.types';
import { Attendance } from '../models/attendance.model';
import { LeadSource } from '../models/lead-source.model';

@Injectable({ providedIn: 'root' })
export class LeadSourceService extends AbstractService<LeadSource> {

  getURLBase(): string {
    return '/lead-source';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: LeadSource): void {
    delete obj?._id;
  }

  preUpdate(obj: LeadSource): void {
  }

  getReportKpisLeadSource(queryParams: Partial<SearchParams>, search?: string): Observable<any> {
    const baseURL = `/report/kpis?`;
    const getSearchConfig = (search: string): string => {
      if (!!search) {
        if (search.includes('+')) {
          const searches = search.split('+');
          let urlSearches = '';
          searches.forEach((search) => {
            urlSearches += `&search=${search}`;
          });
          return urlSearches;
        } else {
          return '&search=' + encodeURIComponent(search);
        }
      } else {
        return '';
      }
    }
    const searching = `${baseURL}${getSearchConfig(search)}`;

    let urling = `${searching}`;
    if (!!queryParams) {
      for (let param in queryParams) {
        urling = `${urling}&${param}=${queryParams[param]}`;
      }
    }

    return super.get(urling);
  }

  getReportAttendancesByLeadSource(page: number, perPage: number, search?: string, params?: Partial<SearchParams>): Observable<Pager<Attendance>> {
    const baseURL = `/report/attendances`;
    const pager = `${baseURL}?page=${page}&perPage=${perPage}`;


    const getSearchConfig = (search: string): string => {
      if (!!search) {
        if (search.includes('+')) {
          const searches = search.split('+');
          let urlSearches = '';
          searches.forEach((search) => {
            urlSearches += `&search=${search}`;
          });
          return urlSearches;
        } else {
          return '&search=' + encodeURIComponent(search);
        }
      } else {
        return '';
      }
    }
    const searching = `${pager}${getSearchConfig(search)}`;

    let urling = `${searching}`;
    if (!!params) {
      for (let param in params) {
        urling = `${urling}&${param}=${params[param]}`;
      }
    }
    return super.get(urling);
  }

}
